import { ConfigurationFieldType } from '@ydistri/api-sdk';
import { useCategoryConfiguration } from '../../../../../hooks/useCategoryConfiguration';
import { useMemo } from 'react';
import { EntityListConfiguration } from '@ydistri/utils';
import { isScopeConfigurationExclusionVariant, parseEntityListConfigs } from './entityListLib';
import { ROOT_CATEGORY_ID } from '../../../../../components/global/_constants';

export const useEntityListExclusion = (
  fieldType: ConfigurationFieldType | undefined,
  entityListId: number,
): {
  fullExcludedConfig: EntityListConfiguration[];
  thisCategoryExcludedConfig: EntityListConfiguration | undefined;
  isExcluded: boolean;
} => {
  const { rootCategoryConfiguration } = useCategoryConfiguration(ROOT_CATEGORY_ID);

  const fullExcludedConfig = useMemo(() => {
    if (!fieldType || !isScopeConfigurationExclusionVariant(fieldType)) {
      return [];
    }
    if (rootCategoryConfiguration) {
      return parseEntityListConfigs(rootCategoryConfiguration[fieldType].FastMover);
    }
    return [];
  }, [fieldType, rootCategoryConfiguration]);

  const thisCategoryExcludedConfig = useMemo(
    () => fullExcludedConfig.find(c => c.EntityListId === entityListId),
    [entityListId, fullExcludedConfig],
  );

  const isExcluded = thisCategoryExcludedConfig !== undefined;

  return useMemo(
    () => ({
      fullExcludedConfig,
      thisCategoryExcludedConfig,
      isExcluded,
    }),
    [fullExcludedConfig, isExcluded, thisCategoryExcludedConfig],
  );
};
